// Arquivo: src/store/modules/motivos.js

import api from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  actions: {
    async find({ commit }) {
      const { data } = await api.get('motivonaoconvertido');
      commit('SET_LIST', data);
      return data;
    },
  },

  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
